import {APP_INITIALIZER, NgModule, LOCALE_ID} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CoreModule} from "./core/core.module";
import {LayoutModule} from "./layout/layout.module";
import {SharedModule} from "./shared/shared.module";
import {RoutesModule} from "./routes/routes.module";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {NgxPermissionsModule} from "ngx-permissions";
import {DecimalPipe} from "@angular/common";
import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';
import { TreeModule } from 'angular-tree-component';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { JvCommonModule } from '../../projects/jv-common/src/lib/jv-common.module';
import { AccountingModule } from '../../projects/accounting/src/lib/accounting.module';
import { JvUiModule } from '../../projects/jv-ui/src/lib/jv-ui.module';

registerLocaleData(localeVi, 'vi');

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    JvCommonModule,
    JvUiModule,
    AccountingModule,

    DeviceDetectorModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule, // required for ng2-tag-input,
    CoreModule,
    LayoutModule,
    SharedModule.forRoot(),
    RoutesModule,
    TreeModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      backdropBackgroundColour: 'rgba(128,128,128,0.4)',
      backdropBorderRadius: '4px',
      primaryColour: '#35aabe',
      secondaryColour: '#11dfaa',
      tertiaryColour: '#000000'
    }),
    NgxPermissionsModule.forRoot()
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'vi' },
    DecimalPipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
